import { Component, Input } from '@angular/core';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzTableModule } from 'ng-zorro-antd/table';
import { TranslateModule } from '@ngx-translate/core';

import { FlexModule } from '@angular/flex-layout';
import { IProcedureDetailed } from '../../../../../../../interfaces/Procedure/IProcedureDetailed';

@Component({
  selector: 'app-procedure-expand',
  standalone: true,
  templateUrl: './procedure-expand.component.html',
  styleUrls: ['./procedure-expand.component.css'],
  imports: [NzLayoutModule, NzTableModule, TranslateModule, FlexModule],
})
export class ProcedureExpandComponent {
  @Input() item: IProcedureDetailed = {};
}
